import { useRef as c, useState as h, useEffect as u } from "react";
import { useMinimumCropValues as m, useImageProperties as a } from "./index15.js";
const g = () => {
  const e = m(), s = a(), { ref: r, size: t } = d(), i = t.width / s.width;
  return {
    ref: r,
    elementWidth: t.width,
    elementHeight: t.height,
    width: e.width * i,
    height: e.height * i
  };
}, d = () => {
  const e = c(null), [s, r] = h({ width: 0, height: 0 });
  return u(() => {
    if (!e.current)
      return;
    const t = new ResizeObserver(([i]) => {
      if (i) {
        const { width: n, height: o } = i.contentRect;
        r({ width: n, height: o });
      }
    });
    return t.observe(e.current), () => t.disconnect();
  }, []), { ref: e, size: s };
};
export {
  d as useElementSize,
  g as useScaledMinimumCropValues
};
